import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import AccountLoged from "@/shared/mixins/AccountLoged";


export default {
  name:'GerarCartaPropostaInicio',
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton
  },

  mounted () {
    // this.popularDropDownCliente()
    var cartaId = this.$route.params.id
    this.CartaPropostaId = cartaId
    this.popularDropDownEmpresa()

    this.RepresentantesArray = this.$store.state.RepresentanteArray

    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
  },

  data () {
    return {
      RepresentanteSelecionado:null,
      RepresentantesArray:[],

      ClienteSelecionado:null,
      ClientesArray:[],

      EmpresaSelecionada:null,
      EmpresaArray:[],
      CartaPropostaId: null,
      escritobotao: true,
      timer: null,
    }
  },

  mixins:[AccountLoged],

  methods: {
    atualizaEmpresaRepresentante(){
      this.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
      this.RepresentanteSelecionado = this.$store.state.representanteSelecionadoId;
    },
    Continuar(){
      if(this.ClienteSelecionado != null && this.RepresentanteSelecionado != null && this.EmpresaSelecionada!=null ){
        this.gerarCartaProposta()
        }
      else{
        this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'Cliente, Unidade e Representante são campos obrigatórios', life: 5000 });
      }
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.getClienteDropDownsByNome(event, this.EmpresaSelecionada, this.RepresentanteSelecionado).ClientesArray;
      }, 1000);
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario( event).RepresentanteArray;
      }, 1000);
    },

    popularDropDownRepresentante(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Representante/GetRepresentanteByCliente/${this.ClienteSelecionado}`,

      })
        .then((response) => {
          this.RepresentantesArray = response.data.data
        })
        .catch(() => {
        });
    },

    popularDropDownCliente(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Cliente/get',
      })
        .then((response) => {
          this.ClientesArray = response.data.data
        })
        .catch(() => {
        });
    },

    popularDropDownEmpresa(){
      this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
      this.atualizaEmpresaRepresentante()
    },

    zerarcampos(){
      this.RepresentanteSelecionado = null;
      this.ClienteSelecionado = null;
    },

    gerarCartaProposta(){
      this.escritobotao = false
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'CartaProposta/post',
        data: {
          ClienteId: this.ClienteSelecionado,
          RepresentanteId: this.RepresentanteSelecionado,
          EmpresaId: this.EmpresaSelecionada,
        }
      })
      .then((response) => {
        if(response.data.data === null) {
          this.escritobotao = true
          return
        }else{
          this.CartaPropostaId=response.data.data
          this.escritobotao = true
        }

        this.$router.push(`/gerar-carta-proposta/${this.CartaPropostaId}/orcamento`)
      })
      .catch(() => {

      });
    }

  }
}